import React, { Component } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import Link from '../Link'
import ArrowRight from '../../../assets/images/ArrowRight.svg'
import { preventOrphan } from '../../utils'

export default class LearnMoreGrid extends Component {
  render() {
    var props = this.props

    return (
      <div className={styles.lightWrapper}>
        <div className="wrapper">
          <div className={styles.container}>
            <div className={styles.grid}>
              <h2>
                {props.nodeLocale.indexOf('jp') !== -1
                  ? preventOrphan(props.title)
                  : props.title}
              </h2>
              {props.components.map((cell, idx) => (
                <div className={styles.cell} key={idx}>
                  <div className={styles.innerCell}>
                    <h4>
                      {cell.link != null && cell.link.length > 0 ? (
                        <Link to={cell.link}>{cell.title}</Link>
                      ) : (
                        cell.title
                      )}
                    </h4>
                    <span>{cell.subtitle.subtitle}</span>
                    {cell.ctaUrl && cell.ctaText && (
                      <Link to={cell.ctaUrl}>
                        {cell.ctaText}
                        <ArrowRight
                          style={{
                            display: 'inline',
                            alignSelf: 'center',
                            position: 'relative',
                            left: '10px',
                          }}
                        />
                      </Link>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.featureImage}>
              <GatsbyImage
                image={props.images[0].gatsbyImageData}
                imgStyle={{ objectFit: 'contain' }}
                alt={props.images[0].description}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
